import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames';
import { t } from '../../../helpers/t';

export function ListingPhotosList() {
  const { open_drafts, listing_photos, title } = useSelector((state) => state.listing);
  const draft = get(open_drafts, '[0].photos');

  return (
    <div className="px-4 md:px-0 py-6">
      <h2 id="photos" className="text-stone-900 text-2xl font-semibold mb-4">
        {t('listings.show.sections.photos.header')}
      </h2>
      {
        draft ? (
          <>
            <div className="listing-photos-container grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2" data-ng-class="{'draft-original': viewingDraft}">
              {listing_photos.map((photo, index) => (
                <div key={`listing-photo-${index}`} className="photo-container rounded">
                  <img
                    className="listing-photo"
                    data-photo-index={index}
                    data-ng-click="openCarousel($event, { source: 'photoGallery'})"
                    src={photo.small_url}
                    alt={t('listings.show.sections.photos.alt', { index: index + 1, title })}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
            <div className="listing-photos-container grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 draft py-2" data-ng-show="viewingDraft">
              {draft.map((photo, index) => (
                <div key={`listing-photo-${index}`} className="photo-container rounded">
                  <a target="_blank" href={photo.original_url || photo.x_large_url || photo.large_url} rel="noopener noreferrer">
                    <img
                      className="listing-photo"
                      src={photo.small_url}
                      alt={t('listings.show.sections.photos.alt', { index: index + 1, title })}
                      loading="lazy"
                    />
                  </a>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="listing-photos-container grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
            {listing_photos.map((photo, index) => (index < 8) && (
              <div key={`listing-photo-${index}`} className={classNames('photo-container relative rounded', (index >= 6) ? 'hidden md:flex' : 'flex')}>
                {
                  (index === 5 || index === 7) && (
                    <div className={classNames((index === 5 ? 'md:hidden' : ''), 'flex absolute w-full h-full left-0 top-0 bg-stone-900/80 text-white items-center justify-center text-md z-10 font-normal pointer-events-none')}>
                      {t('listings.show.sections.photos.showMore')}
                    </div>
                  )
                }
                <img
                  className="listing-photo"
                  data-photo-index={index}
                  data-ng-click="openCarousel($event, { source: 'photoGallery'})"
                  src={photo.small_url}
                  alt={t('listings.show.sections.photos.alt', { index: index + 1, title })}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}
